// extracted by mini-css-extract-plugin
module.exports = {"label":"Input_label__UFHtv","input":"Input_input__3KukG","textarea":"Input_textarea__1_lfq","text":"Input_text__3t7eO"};